import { render, staticRenderFns } from "./Follow.vue?vue&type=template&id=0b455efe&scoped=true"
import script from "./Follow.vue?vue&type=script&lang=js"
export * from "./Follow.vue?vue&type=script&lang=js"
import style0 from "./Follow.vue?vue&type=style&index=0&id=0b455efe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b455efe",
  null
  
)

export default component.exports